import Swal from "sweetalert2";

import api from "./api";
import { CreateBancoDto, GetBancoDto, UpdateBancoDto } from "../shared/dtos/Banco.dto";
import { ResultDto } from "../shared/dtos/Result.dto";

class BancoService {
  async getBancos(): Promise<GetBancoDto[]> {
    return api
      .get("/banco/getAll")
      .then((response) => {
        return Promise.resolve(response.data as GetBancoDto[]);
      })
      .catch((error) => {
        this.handleError(error, `Erro ao buscar bancos`);
        return Promise.reject(error);
      });
  }

  async getBancoById(id: number): Promise<GetBancoDto> {
    return api
      .get(`/banco/findOne/${id}`)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        this.handleError(error, `Erro ao buscar lotação com ID ${id}`);
        return Promise.reject(error);
      });
  }

  async createBanco(bancoData: CreateBancoDto): Promise<GetBancoDto> {
    return api
      .post("/banco/create", bancoData)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        this.handleError(error, "Erro ao criar lotação");
        return Promise.reject(error);
      });
  }

  async updateBanco(id: number, bancoData: UpdateBancoDto): Promise<GetBancoDto> {
    return api
      .patch(`/banco/update/${id}`, bancoData)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        this.handleError(error, `Erro ao atualizar lotação com ID ${id}`);
        return Promise.reject(error);
      });
  }

  async deleteBanco(id: number): Promise<void> {
    return api
      .delete(`/banco/delete/${id}`)
      .then(() => {
        return Promise.resolve();
      })
      .catch((error) => {
        this.handleError(error, `Erro ao deletar lotação com ID ${id}`);
        return Promise.reject(error);
      });
  }

  async getBancosInBrasilAPI(): Promise<ResultDto> {
    return api
      .get(`/banco/updateBancosInBrasilAPI`)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        this.handleError(error, `Erro ao atualizar bancos`);
        return Promise.reject(error);
      });
  }

  private handleError(error: any, message: string): void {
    if (error.response) {
      Swal.fire({
        title: "Erro",
        text: `${message}: ${error.response.data}`,
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    } else {
      Swal.fire({
        title: "Erro",
        text: `${message}: ${error.message || "Erro desconhecido"}`,
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    }
  }
}

const bancoService = new BancoService();
export default bancoService;
